module.exports = __webpack_public_path__ + "static/media/materials-science.4f881c40.svg";